<template>
  <div class="container">
    <div class="synchronous">
      <el-button type="danger" @click="synchronous">立即同步企业微信组织</el-button>
    </div>
<!--    default-expand-all-->
    <el-tree
        style="max-width:400px"
        :data="treeData"
        node-key="id"
        :expand-on-click-node="false"
    >
      <template #default="{ node, data }">
        <div class="custom-tree-node">
          <span>{{ node.label }}</span>
          <div>
            <el-button
                style="margin-left: 4px"
                type="warning"
                link
                @click="option(node, data)"
            > 编辑权限</el-button>
          </div>
        </div>
      </template>
    </el-tree>
    <perMission ref="perMissionEdit"  @closeEdit="close" ></perMission>
  </div>
</template>
<script >
import {ElTree,ElButton} from "element-plus";
import perMission from "@/components/perMission.vue";
import {getDepartment,setDepartmentPermission,getSynchronous} from "@/utils/api";
export default {
  name: "kangRongDepart",
  components: {
    ElTree,ElButton,perMission
  },
  data(){
    return{
      treeData:[],
      curDepart:{}
    }
  },
  beforeMount() {
    this.getDepartment()
  },
  methods:{
    getDepartment(){
      getDepartment().then(res=>{
        console.log(res);
        this.treeData = res.Data
        localStorage.setItem('department',JSON.stringify(res.Data))
      }).catch(err=>{
        console.log(err)
      })
    },
    option(node, data){
      this.curDepart = data
      console.log(node)
      console.log(data)
      let preData = []
      if ( data.permission === null){
        preData = []
      }else{
        try {
          preData = JSON.parse(data.permission)
        }catch(err){
          preData = data.permission
        }
      }
      this.$refs.perMissionEdit.openEdit(preData)
    },
    close(data){
      console.log(data)
      console.log(this.curDepart)
      if(data){
        setDepartmentPermission({id:this.curDepart.value,permission:data}).then(res=>{
          console.log(res)
          this.$refs.perMissionEdit.closeEdit()
          this.getDepartment()
        }).catch(err=>{
          console.log(err)
        })
      }
    },
    synchronous(){
      getSynchronous().then(res=>{
        console.log(res)
      }).catch(err=>{
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>
.container{
  width: 90%;
  margin: 0 auto;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.synchronous{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 20px 0;
}
</style>